// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commentCard {
    border-radius: 15px;
}

.commentCard__header {
    background-color: #e6e6e6;
}

.commentCard__attachmentsContainer {
    padding: 1rem;
}

.commentCard__icon {
    transition: all 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.commentCard__icon--straight {
    rotate: 0;
}

.commentCard__icon--lean {
    rotate: 25deg;
}
`, "",{"version":3,"sources":["webpack://./src/components/comments/commentCard/CommentCard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".commentCard {\n    border-radius: 15px;\n}\n\n.commentCard__header {\n    background-color: #e6e6e6;\n}\n\n.commentCard__attachmentsContainer {\n    padding: 1rem;\n}\n\n.commentCard__icon {\n    transition: all 300ms;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.commentCard__icon--straight {\n    rotate: 0;\n}\n\n.commentCard__icon--lean {\n    rotate: 25deg;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
